var borders_default = {
  "borderT": "sUPh5",
  "borderB": "asLDK",
  "borderL": "_1kmLz",
  "borderR": "pJc2l"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
